import './assets/DropDownMLP1.css';const o = "#ffffff", d = "#396e75", a = "#e5fdff", e = "#546223", n = "#f0fae5", r = "#a65523", t = "#fff1e8", i = "#7f3e3e", l = "#ffe2e2", c = "#62625a", _ = "#f8f8e7", s = "#38539a", p = "#707070", w = "#c8f8d1", m = "#87c9c8", g = "#5291b1", f = "rgba(82, 145, 177, 0.1019607843)", z = "#445685", V = "#181d61", u = "rgba(24, 29, 97, 0.1019607843)", b = "#5969d6", C = "#ea999d", h = "#b6577e", k = "rgba(182, 87, 126, 0.1019607843)", v = "#7e3e80", B = "#1e247f", G = "rgba(30, 36, 127, 0.1019607843)", O = "#da7600", R = "#107f47", W = "#d91734", y = "_html_d8ocm_46", Y = "_disabled_d8ocm_235", x = "_selected_d8ocm_320", P = {
  amwayWhite: o,
  darkBlue: d,
  lightBlue: a,
  darkGreen: e,
  lightGreen: n,
  darkOrange: r,
  lightOrange: t,
  darkRed: i,
  lightRed: l,
  darkYellow: c,
  lightYellow: _,
  darkPurple: s,
  darkGrayOnWhite: p,
  dataVizColor1: w,
  dataVizColor2: m,
  dataVizColor3: g,
  dataVizColor3Background: f,
  dataVizColor4: z,
  dataVizColor5: V,
  dataVizColor5Background: u,
  dataVizColor6: b,
  dataVizColor7: C,
  dataVizColor8: h,
  dataVizColor8Background: k,
  dataVizColor9: v,
  dataVizColor10: B,
  dataVizColor10Background: G,
  dataVizAlertOrange: O,
  dataVizSuccessGreen: R,
  dataVizWarningRed: W,
  "no-visible": "_no-visible_d8ocm_42",
  html: y,
  "focused-border": "_focused-border_d8ocm_80",
  "dropdown-container": "_dropdown-container_d8ocm_80",
  "base-dropdown-result": "_base-dropdown-result_d8ocm_80",
  "open-dropdown-result": "_open-dropdown-result_d8ocm_80",
  "dropdown-container-modal": "_dropdown-container-modal_d8ocm_81",
  "dropdown-box": "_dropdown-box_d8ocm_81",
  "dropdown-field-result": "_dropdown-field-result_d8ocm_81",
  "dropdown-message": "_dropdown-message_d8ocm_99",
  "dropdown-label": "_dropdown-label_d8ocm_103",
  "dropdown-tool-tip": "_dropdown-tool-tip_d8ocm_114",
  "with-flag": "_with-flag_d8ocm_138",
  "phone-number-flag": "_phone-number-flag_d8ocm_142",
  "dropdown-field": "_dropdown-field_d8ocm_81",
  "dropdown-field-disable": "_dropdown-field-disable_d8ocm_189",
  "dropdown-icon": "_dropdown-icon_d8ocm_200",
  "icon-desktop": "_icon-desktop_d8ocm_208",
  "dropdown-active": "_dropdown-active_d8ocm_219",
  "dropdown-validated-valid": "_dropdown-validated-valid_d8ocm_227",
  "dropdown-validated-invalid": "_dropdown-validated-invalid_d8ocm_231",
  disabled: Y,
  "base-dropdown-valid": "_base-dropdown-valid_d8ocm_271",
  "base-dropdown-invalid": "_base-dropdown-invalid_d8ocm_275",
  "flag-icon-container": "_flag-icon-container_d8ocm_301",
  selected: x,
  "dropdown-message-valid": "_dropdown-message-valid_d8ocm_368",
  "dropdown-message-invalid": "_dropdown-message-invalid_d8ocm_372",
  "disabled-container": "_disabled-container_d8ocm_377",
  "search-input": "_search-input_d8ocm_466",
  "search-input-wrapper": "_search-input-wrapper_d8ocm_474",
  "search-icon": "_search-icon_d8ocm_495",
  "skeleton-loading": "_skeleton-loading_d8ocm_1"
};
export {
  P as d
};
//# sourceMappingURL=DropDownMLP1.module-cbdfc4d8.mjs.map
